module.exports = __webpack_public_path__ + "static/img/solvedSuccessfully.e06de4f.png";


//////////////////
// WEBPACK FOOTER
// ./src/themes/dragon/img/solvedSuccessfully.png
// module id = kAWD
// module chunks = 1